module.exports = __webpack_public_path__ + "img/footer-screen.png";